<template>
  <div class="container menus">
    <van-cell-group class="menus__list">
      <van-cell icon="label" title="电子发票" size="large" is-link to="invoice" />
      <!-- <van-cell icon="vip-card" title="我的积分" size="large" is-link to="credit-score" /> -->
      <!-- <van-cell icon="coupon" title="优惠券" size="large" is-link to="coupon" /> -->
      <!-- to="coupon"  -->
      <!-- <van-cell icon="debit-pay" title="无感支付" size="large" is-link @click="linkComponents" /> -->
    </van-cell-group>
  </div>
</template>

<script>
import { CellGroup } from 'vant'
import { mapGetters } from 'vuex'
import config from '@/config/index'

export default {
  name: 'Wallet',
  components: {
    [CellGroup.name]: CellGroup
  },
  computed: {
    ...mapGetters([
      'NBPSS'//平台用户信息
    ]),
  },
  data () {
    return {
      config
    }
  },
  created () {
  },
  destroyed () {  // 销毁时取消监听
  },
  methods: {
    // 跳转
    linkComponents () {
      this.$toast('暂未开通 敬请期待！')
    }
  }
}
</script>

<style lang="scss" scoped>
.menus {
  height: 100vh;
  background: #f4f6f7;

  &__list {
    &__icon {
      font-size: 20px;
      line-height: 24px;
      margin-right: 5px;
      height: 24px;
    }
  }
}
</style>